import { Col, Popover, Space, Typography } from "antd";
import routes from "../../../engine/routes";
import React from "react";
import { useParams } from "react-router-dom";
import { RenderTitle } from "../../../engine/AuthRoute/navigationHelper";
import LogHistory from "../LogHistory";
import { useSelector } from "react-redux";
import { daysJsFormat as datesFormats, roles } from "../../../utils/constants";
import { ActionRoleSpecific } from "../../../engine/AuthRoute";
import { BillAction } from "../BillAction/BillAction";
import dayjs from "../../../utils/dayjs";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { RenderlastDownload, RenderlastSent } from "./Bill.helpers";

export const BillHeader = ({ title }) => {
  const { t } = useTranslation();
  const { loading, bill } = useSelector(state => state.bill);

  return (
    <Col span={24} style={{ marginBottom: 20 }}>
      <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
        <LogHistory updateEndPoint={[loading, bill]} />
      </ActionRoleSpecific>
      <div style={{ textAlign: "right" }}>
        {<RenderlastSent bill={bill} key={bill._id + loading.toString()} />}
      </div>
      <div style={{ textAlign: "right" }}>
        {bill._id !== undefined && (
          <RenderlastDownload
            bill={bill}
            key={bill._id + loading.toString()}
            loadOnInit={true}
          />
        )}
      </div>
      <Space
        style={{
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={3} className={""}>
          <RenderTitle title={title} />
        </Typography.Title>
        <BillAction />
      </Space>
    </Col>
  );
};
